import type { ReactNode } from "react";

const NOTATION_RE = /(\^{[^}]+}|_{[^}]+})/g;

export default function ScientificText({
  children,
}: {
  children: string;
}): ReactNode {
  const parts = children.split(NOTATION_RE);

  if (parts.length === 1) return children;

  return (
    <>
      {parts.map((part, i) => {
        if (part.startsWith("^{") && part.endsWith("}")) {
          return <sup key={i}>{part.slice(2, -1)}</sup>;
        }
        if (part.startsWith("_{") && part.endsWith("}")) {
          return <sub key={i}>{part.slice(2, -1)}</sub>;
        }
        return <span key={i}>{part}</span>;
      })}
    </>
  );
}

export function preprocessScientificNotation(text: string): string {
  return text
    .replace(/\^{([^}]+)}/g, "<sup>$1</sup>")
    .replace(/_{([^}]+)}/g, "<sub>$1</sub>");
}
